<panel style="min-width: 450px">
  <menu always-visible>
    <menuitem (click)="createNewAccountingPlanSetup()">{{ 'accounting-plan-setup-list.create' | translate }}</menuitem>
  </menu>
  <h1>{{ 'accounting-plan-setup.list' | translate }}</h1>
  @if (accountingPlanSetups) {
    <list-view [selectable]="true" class="scrollable">
      <ng-container *listData="let setup from accountingPlanSetups">
        <row (action)="selectedAccountingPlanSetup = setup">
          <column>{{ setup.name }}</column>
        </row>
      </ng-container>
    </list-view>
  }
</panel>

@if (selectedAccountingPlanSetup) {
  <accounting-plan-setup [accountingPlanSetup]="selectedAccountingPlanSetup" />
}
